import type ProtectionStore from 'owa-mail-protection-types/lib/schema/ProtectionStore';
import { createStore } from 'satcheljs';
import getDefaultProtectionStore from '../utils/getDefaultProtectionStore';

export const getStore = createStore<ProtectionStore>('protection', getDefaultProtectionStore());
export const protectionStore = getStore();
